<template>
    <div style="background: white">
        <policyHeader/>
        <div class="breadBox">
            <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item @click="onRollback" style="cursor:pointer">通知公告</a-breadcrumb-item>
                <a-breadcrumb-item>{{noticeObj.title}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div id="print" class="tabBox">
            <div class="title">{{noticeObj.title}}</div>
            <div class="subtitle">
                <span>来源:{{noticeObj.origin}}</span>
                <span> 发布日期:{{noticeObj.publishTime}}</span>
                <span onselectstart="return false;"> 字体: <span style="cursor: pointer;margin:0" @click="sizes++">【放大】</span><span style="cursor: pointer;margin:0" @click="sizes--">【缩小】</span><span style="cursor: pointer;margin:0" @click="sizes=16">【标准】</span>
                <PrintOn></PrintOn>
            </span>
                <div class="collect" @click="onCollect(noticeObj.title)" v-if="!collectShow">
                    <StarOutlined/>
                    收藏
                </div>
                <div class="collect" @click="oncancel" v-if="collectShow">
                    <StarOutlined/>
                    已收藏
                </div>

            </div>
            
            <div class="titlecontent" :style="{ fontSize: sizes + 'px' }" >{{noticeObj.contentAbstract}}</div>
            <div class="content" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.content"></div>
        </div>
    </div>

</template>
<script>
import { basicsEssayInfoweb } from "@/api/finance";
import {collectWeb} from "@/api/innovationService";

export default {
    name:"noticeDetail",
    components:{},
    data(){
        return{
            sizes:16,
            collectShow: false,
            noticeObj:{}
        }
    },
    methods:{
    onCollect(title) {
            if(this.$ls.get('token')){
                
            let collUrl = window.location.href
            this.postAction({
                url: collectWeb.saveOrUpdate,
                params: {
                    title: title,
                    type: "g",
                    url: collUrl,
                    systemType: 'finance'
                }
            }).then(res => {
                console.log(res, 'res')
                
        this.$notification.success({
                                message: '收藏成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
            }else{
                
        this.$notification.warning({
                                message: '登录后可以操作',
                                style: {
                                    fontWeight: '600',
                                },
                            });
this.$router.push({ path: '/login', query: { id: 'user' } })
            }
        },
        getIsCollect() {
            this.getAction({
                url:collectWeb.Iscancel,
                params:{
                    urls:window.location.href,
                    systemType: 'finance'
                }
            }).then(res=>{
                this.collectShow = res
            })
        },
        
        oncancel(){
            this.postAction({
                url:collectWeb.romver,
                params:{
                    urls:window.location.href,
                    systemType: 'finance'
                }
            }).then(()=>{
        this.$notification.success({
                                message: '取消收藏',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
        },
        getDetail(){
            this.getAction({
                url:basicsEssayInfoweb.getDetail,
                params:{id:this.$route.query.id}
            }).then(res=>{
                this.noticeObj= res
            })
        },
        onRollback(){
            this.$router.push({
                path:"/finance/notice",
                query:{
                    type:"通知公告"
                }
            })
        },
        onRollbackHome(){
            this.$router.push({
                path:"/finance/index",
                query:{
                    type:"首页"
                }
            })
        }
    },
    mounted() {
        this.getDetail()
    }
}
</script>
<style lang="less" scoped>
.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}
.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;
    .title{
        text-align: center;
        font-size: 30px;
        color: #333;
    }
    .subtitle{
        position: relative;
        font-size: 14px;
        margin-top: 30px;
        padding-bottom: 20px;
        color: #333;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: center;
        span{
            margin: 0 20px;
        }
        
        
    }
    
    .titlecontent{
        text-align: center;
        font-size: 16px;
        margin-top: 60px;
        font-weight: 600;
        padding:0 10%;
        line-height: 40px;
    }
    .content{
        padding:0 10%;
        font-size: 16px;
        line-height: 30px;
        margin-top: 60px;
        text-indent: 30px;
        :deep(img){
            width:60%;
            margin-left: 18%;
            margin-bottom: 20px;
        }
        :deep(p){
            line-height: 40px;
        }
    }
}
.collect {
    border:1px solid #2162e4;
    padding:6px 0;
    text-align: center;
    width:135px;
    color:#2162e4;
    font-size: 15px;
    position: absolute;
    right: 0;
    top:-5px;
    cursor: pointer;
    span{
        margin:0!important
    }
  }
</style>
